module.exports = __webpack_public_path__ + "img/20190827144632946.238426ef.jpg";